import styled from '@emotion/styled';
import { font, palette, remCalc, mediaQueries } from '../../css';

const StyledWrapper = styled('div')(() => ({
    position: 'relative',
}));

const StyledLink = styled('a')(() => ({
    outline: 'none',
}));

const StyledCaption = styled('div')(() => ({
    display: 'flex',
    position: 'absolute',
    top: remCalc(20),
    bottom: 0,
    left: remCalc(35),
    right: 0,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    zIndex: 1,
    [mediaQueries.medium]: {
        top: 0,
        left: remCalc(76),
        alignItems: 'center',
    },
    [mediaQueries.large]: {
        left: remCalc(86),
    },
}));

const StyledDate = styled('span')(() => ({
    position: 'absolute',
    display: 'none',
    top: 0,
    left: remCalc(35),
    fontFamily: font.family.header,
    fontSize: font.size.m,
    fontWeight: font.weight.regular,
    color: palette('white'),
    zIndex: 1,
    [mediaQueries.medium]: {
        display: 'block',
        top: '10%',
        left: remCalc(76),
    },
    [mediaQueries.large]: {
        left: remCalc(86),
    },
}));

const StyledDescription = styled('p')(() => ({
    position: 'absolute',
    display: 'none',
    bottom: 0,
    left: remCalc(35),
    fontSize: font.size.s,
    lineHeight: font.lineHeight.m,
    color: palette('white'),
    zIndex: 1,
    [mediaQueries.medium]: {
        display: 'block',
        bottom: '10%',
        left: remCalc(76),
    },
    [mediaQueries.large]: {
        left: remCalc(86),
    },
}));

export { StyledCaption, StyledDate, StyledDescription, StyledLink, StyledWrapper };
